"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Roles = void 0;
var Roles;
(function (Roles) {
    Roles["Admin"] = "ADMIN";
    Roles["User"] = "USER";
    Roles["SuperAdmin"] = "SUPERADMIN";
})(Roles = exports.Roles || (exports.Roles = {}));
//# sourceMappingURL=roles.js.map